export const videos = [
  {
    id: 1,
    title: '星际穿越：人类最后的希望之地',
    slug: 'star-wanderer-final-hope',
    category: 'dianying',
    description: '在遥远的未来，地球资源枯竭，人类面临灭绝危机。一群勇敢的宇航员穿越虫洞，前往未知星系寻找新家园。他们将在宇宙的极端环境中展开一场惊心动魄的冒险旅程。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20space%20scene%20with%20astronaut%20floating%20near%20wormhole%2C%20distant%20galaxy%20in%20background%2C%20dramatic%20warm%20golden%20and%20coral%20nebula%20lighting%2C%20cinematic%20composition%2C%20high%20detail%2C%20atmospheric%2C%20film%20poster%20style&width=800&height=450&seq=video-thumb-01&orientation=landscape',
    duration: '2:48:32',
    views: 1285000,
    author: '影评人老王',
    date: '2026-07-28',
    rating: 9.3,
    isHot: true,
    tags: ['科幻', '冒险', '太空', '高分'],
    content: '...',
  },
  {
    id: 2,
    title: '舌尖上的江湖：川菜的前世今生',
    slug: 'sichuan-cuisine-history',
    category: 'jilupian',
    description: '深入四川盆地，探寻川菜文化的千年传承。从麻辣火锅到回锅肉，从街头小吃到宫廷御膳，每一道菜背后都蕴含着深厚的历史故事和人文情怀。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Traditional%20Sichuan%20cuisine%20spread%20on%20wooden%20table%20with%20steaming%20hotpot%2C%20colorful%20spices%20in%20bowls%2C%20chopsticks%2C%20warm%20restaurant%20lighting%2C%20rustic%20Chinese%20kitchen%20atmosphere%2C%20rich%20red%20and%20amber%20tones%2C%20food%20photography%20style&width=800&height=450&seq=video-thumb-02&orientation=landscape',
    duration: '1:35:20',
    views: 856000,
    author: '美食探险家小李',
    date: '2026-08-02',
    rating: 9.1,
    isHot: true,
    tags: ['美食', '文化', '川菜', '纪录片'],
    content: '...',
  },
  {
    id: 3,
    title: '爆笑综艺：谁是卧底第十季',
    slug: 'who-is-spy-s10',
    category: 'zongyi',
    description: '全新一季谁是卧底强势回归！明星嘉宾阵容升级，游戏规则全新改版，爆笑名场面不断。看谁能骗过所有人，成为真正的卧底之王！',
    thumbnail: 'https://readdy.ai/api/search-image?query=Colorful%20TV%20variety%20show%20stage%20set%20with%20game%20show%20elements%2C%20bright%20studio%20lights%2C%20celebrities%20laughing%20on%20couches%2C%20confetti%20and%20balloons%2C%20energetic%20atmosphere%2C%20warm%20coral%20and%20gold%20lighting%2C%20entertainment%20photography&width=800&height=450&seq=video-thumb-03&orientation=landscape',
    duration: '1:20:15',
    views: 2350000,
    author: '综艺大咖说',
    date: '2026-08-05',
    rating: 8.9,
    isHot: true,
    tags: ['综艺', '搞笑', '推理', '明星'],
    content: '...',
  },
  {
    id: 4,
    title: '鬼灭之刃：无限列车篇 完整版',
    slug: 'demon-slayer-mugen-train',
    category: 'dongman',
    description: '炎柱炼狱杏寿郎登上无限列车，与鬼展开殊死搏斗。震撼的打斗场面、催人泪下的剧情，这部剧场版将带给你前所未有的视听体验。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Anime%20style%20battle%20scene%20with%20flame%20effects%20on%20moving%20train%2C%20dynamic%20sword%20action%2C%20dramatic%20warm%20fire%20and%20amber%20lighting%2C%20cinematic%20anime%20composition%2C%20high%20energy%2C%20Japanese%20anime%20aesthetic%2C%20vibrant%20coral%20and%20gold%20tones&width=800&height=450&seq=video-thumb-04&orientation=landscape',
    duration: '1:57:08',
    views: 4560000,
    author: '动漫速递',
    date: '2026-07-15',
    rating: 9.6,
    isHot: true,
    tags: ['动漫', '热血', '战斗', '剧场版'],
    content: '...',
  },
  {
    id: 5,
    title: '周杰伦2026世界巡回演唱会 台北站',
    slug: 'jay-chou-taipei-2026',
    category: 'yinyue',
    description: '华语乐坛天王周杰伦2026世界巡回演唱会台北站全程实录。经典歌曲连唱，震撼舞美设计，带你重温那些年的青春记忆。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Grand%20concert%20stage%20with%20spectacular%20lighting%20effects%2C%20massive%20LED%20screens%2C%20laser%20beams%2C%20packed%20arena%20crowd%20with%20light%20sticks%2C%20atmospheric%20music%20performance%2C%20warm%20golden%20and%20coral%20stage%20lights%2C%20live%20concert%20photography&width=800&height=450&seq=video-thumb-05&orientation=landscape',
    duration: '3:15:42',
    views: 8900000,
    author: '音乐现场',
    date: '2026-08-01',
    rating: 9.5,
    isHot: true,
    tags: ['音乐', '演唱会', '周杰伦', '华语'],
    content: '...',
  },
  {
    id: 6,
    title: '黑神话：悟空 全剧情通关攻略',
    slug: 'black-myth-wukong-walkthrough',
    category: 'youxi',
    description: '国产3A大作黑神话悟空全流程通关攻略。详解每个BOSS的战斗技巧、隐藏道具获取方法，以及多结局达成条件，助你成为真正的齐天大圣！',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythology%20game%20scene%20with%20monkey%20king%20character%2C%20ancient%20temple%20ruins%2C%20dramatic%20golden%20and%20coral%20lighting%2C%20cinematic%20game%20screenshot%20aesthetic%2C%20misty%20atmosphere%2C%20high%20detail%2C%20action%20game%20style&width=800&height=450&seq=video-thumb-06&orientation=landscape',
    duration: '4:22:18',
    views: 5670000,
    author: '游戏攻略组',
    date: '2026-07-20',
    rating: 9.4,
    isHot: true,
    tags: ['游戏', '攻略', '国产', '动作'],
    content: '...',
  },
  {
    id: 7,
    title: 'iPhone 18 Pro Max 深度评测',
    slug: 'iphone-18-pro-max-review',
    category: 'keji',
    description: '苹果最新旗舰iPhone 18 Pro Max全面评测。从外观设计到性能跑分，从相机升级到续航表现，你想知道的一切都在这里。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Sleek%20smartphone%20on%20minimal%20white%20desk%20with%20coffee%20cup%20nearby%2C%20modern%20tech%20workspace%2C%20warm%20natural%20morning%20light%2C%20clean%20product%20photography%2C%20professional%20tech%20review%20aesthetic%2C%20neutral%20warm%20tones&width=800&height=450&seq=video-thumb-07&orientation=landscape',
    duration: '0:45:30',
    views: 1230000,
    author: '科技前线',
    date: '2026-08-06',
    rating: 8.8,
    isHot: false,
    tags: ['科技', '评测', '手机', '数码'],
    content: '...',
  },
  {
    id: 8,
    title: '甄嬛传 完整版全集',
    slug: 'zhen-huan-zhuan-full',
    category: 'dianshiju',
    description: '经典宫斗剧甄嬛传完整版。讲述甄嬛从一个不谙世事的少女成长为善于权谋的皇太后的故事，孙俪、陈建斌领衔主演，豆瓣9.4分神作。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20palace%20interior%20with%20silk%20curtains%2C%20antique%20furniture%2C%20traditional%20lanterns%2C%20imperial%20court%20atmosphere%2C%20warm%20candlelight%20glow%2C%20historical%20Chinese%20drama%20aesthetic%2C%20rich%20amber%20and%20coral%20tones%2C%20cinematic%20composition&width=800&height=450&seq=video-thumb-08&orientation=landscape',
    duration: '76集',
    views: 12000000,
    author: '剧集收藏家',
    date: '2026-06-10',
    rating: 9.7,
    isHot: false,
    tags: ['电视剧', '宫斗', '经典', '国产'],
    content: '...',
  },
  {
    id: 9,
    title: '宇宙的奥秘：黑洞与时间旅行',
    slug: 'cosmos-black-hole-time-travel',
    category: 'jilupian',
    description: '跟随诺贝尔物理学奖得主，一起探索宇宙中最神秘的天体——黑洞。了解时间旅行在理论上的可能性，以及人类对宇宙认知的最新突破。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Majestic%20black%20hole%20with%20accretion%20disk%20in%20deep%20space%2C%20stars%20and%20nebula%20surrounding%2C%20dramatic%20cosmic%20lighting%2C%20scientific%20visualization%20aesthetic%2C%20warm%20golden%20and%20coral%20accretion%20glow%2C%20high%20detail%2C%20documentary%20style&width=800&height=450&seq=video-thumb-09&orientation=landscape',
    duration: '1:52:40',
    views: 789000,
    author: '科学探索者',
    date: '2026-07-12',
    rating: 9.2,
    isHot: false,
    tags: ['纪录片', '科学', '宇宙', '物理'],
    content: '...',
  },
  {
    id: 10,
    title: '进击的巨人 最终季 完结篇',
    slug: 'attack-on-titan-final',
    category: 'dongman',
    description: '进击的巨人最终季完结篇，艾伦与伙伴们的终极对决。十年的史诗故事画上句号，自由与束缚的终极命题等你来见证。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20anime%20final%20battle%20scene%20with%20giant%20titans%20and%20soldiers%2C%20dramatic%20sky%20with%20golden%20sunset%2C%20ruined%20cityscape%2C%20intense%20action%2C%20cinematic%20anime%20composition%2C%20warm%20coral%20and%20amber%20tones%2C%20high%20detail&width=800&height=450&seq=video-thumb-10&orientation=landscape',
    duration: '1:25:00',
    views: 3450000,
    author: '动漫速递',
    date: '2026-08-03',
    rating: 9.8,
    isHot: true,
    tags: ['动漫', '热血', '最终季', '史诗'],
    content: '...',
  },
  {
    id: 11,
    title: '脱口秀大会 第六季',
    slug: 'talk-show-s6',
    category: 'zongyi',
    description: '脱口秀大会第六季重磅回归！新老选手同台竞技，笑料不断。生活、职场、爱情，每一个话题都能让你捧腹大笑的同时引发思考。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Comedy%20club%20stage%20with%20spotlight%20on%20microphone%20stand%2C%20red%20brick%20wall%20background%2C%20warm%20stage%20lighting%2C%20cozy%20performance%20venue%2C%20stand-up%20comedy%20atmosphere%2C%20rich%20coral%20and%20amber%20tones%2C%20entertainment%20photography&width=800&height=450&seq=video-thumb-11&orientation=landscape',
    duration: '1:30:00',
    views: 1890000,
    author: '笑点制造机',
    date: '2026-07-25',
    rating: 8.7,
    isHot: false,
    tags: ['综艺', '脱口秀', '搞笑', '语言'],
    content: '...',
  },
  {
    id: 12,
    title: '我的世界：史诗级建筑教程合集',
    slug: 'minecraft-epic-builds',
    category: 'youxi',
    description: '从零开始教你建造史诗级建筑！城堡、城市、飞船，一步步详细教学。无论你是建筑新手还是老玩家，都能在这里找到灵感。',
    thumbnail: 'https://readdy.ai/api/search-image?query=Minecraft%20epic%20castle%20build%20with%20detailed%20block%20architecture%2C%20torches%20lighting%20up%20the%20scene%2C%20pixel%20art%20aesthetic%2C%20creative%20game%20build%2C%20warm%20golden%20torch%20light%2C%20gaming%20content%20style%2C%20vibrant%20amber%20tones&width=800&height=450&seq=video-thumb-12&orientation=landscape',
    duration: '3:45:20',
    views: 2340000,
    author: '方块建筑师',
    date: '2026-06-28',
    rating: 9.0,
    isHot: false,
    tags: ['游戏', '教程', '建筑', '创意'],
    content: '...',
  },
];

export interface Video {
  id: number;
  title: string;
  slug: string;
  category: string;
  description: string;
  thumbnail: string;
  duration: string;
  views: number;
  author: string;
  date: string;
  rating: number;
  isHot: boolean;
  tags: string[];
  content: string;
}